import apiClient from './client';
import type { User } from '@voc-system/shared';

export interface UpdateProfileDto {
  displayname: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export const usersApi = {
  updateProfile: async (dto: UpdateProfileDto): Promise<User> => {
    const { data } = await apiClient.put('/users/profile', dto);
    return data;
  },

  changePassword: async (dto: ChangePasswordDto): Promise<{ success: boolean }> => {
    const { data } = await apiClient.put('/users/password', dto);
    return data;
  },

  deleteAccount: async (): Promise<{ success: boolean }> => {
    const { data } = await apiClient.delete('/users/account');
    return data;
  },
};
